import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import "./utils/firebase";
//import createPayemntIntent from "./utils/firebase";
//import { getFunctions, httpsCallable } from "firebase/functions";



//const functions = require('firebase-functions');


  
// createPayemntIntent({ amount: 250, paymentMethodId: 12342 })
// .then((result) => {
//   // Read result of the Cloud Function.
//   /** @type {any} */
//   const data = result.data;
//   const sanitizedMessage = data.text;
//   //print(sanitizedMessage)
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
